// extracted by mini-css-extract-plugin
export default {"paper1":"timepicker_paper1__fpPir","paper2":"timepicker_paper2__3GgTI"};